import { cn } from "../../lib/utils";

/** Brand mark: an orthogonal connector with nodes — the "flow" motif in miniature. */
export function LogoMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 32 32"
      className={cn("size-8", className)}
      role="img"
      aria-label="Datamatix Solutions logo"
      fill="none"
    >
      <rect x="1" y="1" width="30" height="30" rx="8" className="fill-brand-600" />
      {/* connector path */}
      <path
        d="M9 11 H16 V21 H23"
        className="stroke-white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* nodes */}
      <circle cx="9" cy="11" r="2.4" className="fill-white" />
      <circle cx="16" cy="21" r="2.4" className="fill-[var(--color-accent)]" />
      <circle cx="23" cy="21" r="2.4" className="fill-white" />
    </svg>
  );
}

/** Full lockup: mark + wordmark. */
export function Logo({ className }: { className?: string }) {
  return (
    <span className={cn("inline-flex items-center gap-2.5", className)}>
      <LogoMark />
      <span className="font-display text-lg font-semibold tracking-tight text-ink">
        Datamatix <span className="text-brand-600 dark:text-brand-500">Solutions</span>
      </span>
    </span>
  );
}
